const content: { [key: string]: string } = {
  pageTitle: "Founders Achievement Award Overview",
};

export default content;
